// Scroll shadow effect for Side_Menu_Container
const initScrollShadow = () => {
    const container = document.getElementById('shop_content');
    const shadow = document.getElementById('scroll_shadow');

    if (!container || !shadow) return;

    // Reset shadow immediately on route change
    shadow.classList.remove('Scroll_Shadow_Visible');

    // Find the scrollable child element (each app has its own scroll container)
    const findScrollableChild = () => {
        const children = container.querySelectorAll('*');
        for (const child of children) {
            const style = getComputedStyle(child);
            const hasScroll = style.overflowY === 'scroll' || style.overflowY === 'auto';
            const isScrollable = child.scrollHeight > child.clientHeight;
            if (hasScroll && isScrollable) {
                return child;
            }
        }
        return null;
    };

    // Debounce to wait for app to mount
    setTimeout(() => {
        const scrollableElement = findScrollableChild();
        if (!scrollableElement) return;

        const handleScroll = () => {
            if (scrollableElement.scrollTop > 10) {
                shadow.classList.add('Scroll_Shadow_Visible');
            } else {
                shadow.classList.remove('Scroll_Shadow_Visible');
            }
        };

        scrollableElement.addEventListener('scroll', handleScroll);
    }, 100);
};

// Initialize when routes change
window.addEventListener('single-spa:routing-event', initScrollShadow);
